import { DateTime } from '@mode-switch/express';
import { Subscription } from 'rxjs';
import * as ChartTypes from '.';
import * as HighchartsEvents from '../highcharts-events.types';

export interface Queue {
  subscribe(componentId: string, hander: Handler): Subscription;
  dispatch(componentId: string, action: Union): void;
}

export type Handler = (action: Union) => boolean | void;

export enum Type {
  MarkClick = 'MARK_CLICK',
  ChartClick = 'CHART_CLICK',
  ContextClick = 'CONTEXT_CLICK',
}

/**
 * General Chart Actions
 */

export interface ChartTarget {
  readonly id: string;
}

export interface ChartClick {
  readonly event: HighchartsEvents.ClickEvent;
  readonly target: ChartTarget;
  readonly type: Type.ChartClick;
}

/**
 * Mark Actions
 */

/**
 * Example: region_name
 *
 * let channel: Color = {
 *   name: 'region_name',
 *   value: 'Northeast',
 *   color: '#f00'
 * }
 *
 */

export interface MarkClick {
  readonly event: HighchartsEvents.ClickEvent;
  readonly target: ChartTypes.MarkTarget;
  readonly position: ChartTypes.MarkPosition;
  readonly type: Type.MarkClick;
}

/**
 * Context Menu Actions
 */

export enum ContextItemType {
  ExploreMark = 'EXPLORE_MARK',
  Drilldown = 'DRILLDOWN',
  Keep = 'KEEP',
  Exclude = 'EXCLUDE',
  ViewData = 'VIEW_DATA',
  DynamicDrillDown = 'DYNAMIC_DRILLDOWN',
}

export type ContextItem =
  | ExploreMarkItem
  | DrilldownItem
  | KeepItem
  | ExcludeItem
  | ViewDataItem
  | DynamicDrilldownItem;

export interface ExploreMarkItem {
  readonly target: ChartTypes.MarkTarget;
  readonly filters: ChartTypes.Filter[];
  readonly type: ContextItemType.ExploreMark;
}

export interface DrilldownItem {
  readonly target: ChartTypes.MarkTarget;
  readonly type: ContextItemType.Drilldown;
}

export interface KeepItem {
  // Put some info here we'll need to response to this action
  readonly type: ContextItemType.Keep;
}

export interface ExcludeItem {
  // Put some info here we'll need to response to this action
  readonly type: ContextItemType.Exclude;
}

export interface ViewDataItem {
  readonly target: ChartTypes.MarkTarget;
  readonly type: ContextItemType.ViewData;
}

export interface DynamicDrilldownItem {
  readonly target: ChartTypes.MarkTarget;
  readonly type: ContextItemType.DynamicDrillDown;
  readonly targetFieldId: string;
  readonly drillToField: string;
  readonly dateTruncUnit?: DateTime.Unit;
}

export interface ContextClick {
  readonly item: ContextItem;
  readonly type: Type.ContextClick;
}

export type Union = MarkClick | ChartClick | ContextClick;
